import { useViewport } from "@/hooks/useViewport";
import clsx from "clsx";
import { useEffect } from "react";

interface NavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  canGoBack: boolean;
  canGoForward: boolean;
  canSubmit: boolean;
  submitButtonColor?: string;
  submitButtonTextColor?: string;
  submitButtonText?: string;
  submitButtonSticky?: boolean;
  submitButtonStickyBackgroundColor?: string;
  isTransparent?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  onPrevious,
  onNext,
  onSubmit,
  canGoBack,
  canGoForward,
  canSubmit,
  submitButtonColor = "#13235b",
  submitButtonTextColor = "white",
  submitButtonText = "OK",
  submitButtonSticky = false,
  submitButtonStickyBackgroundColor = "#d0ebf6db",
  isTransparent = false,
}) => {
  const { isMobile } = useViewport();

  useEffect(() => {
    if (submitButtonSticky && isMobile) {
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [submitButtonSticky, isMobile]);

  return (
    <div
      className={clsx(
        "gap-4 flex justify-between items-center",
        submitButtonSticky
          ? "sticky -bottom-10 backdrop-blur-sm left-0 py-7 right-0 w-full z-10"
          : "relative"
      )}
      style={
        submitButtonSticky
          ? {
              backgroundColor: submitButtonStickyBackgroundColor + "CC",
            }
          : {}
      }
    >
      <div
        className="flex gap-4"
        style={{ color: `${submitButtonTextColor || "#13235b"}` }}
      >
        {canGoBack && (
          <button
            onClick={onPrevious}
            className="p-2 rounded-lg hover:opacity-90 disabled:opacity-50 transition-colors"
            style={
              isTransparent
                ? {
                    backgroundColor: `${submitButtonColor || "#13235b"}50`,
                    color: submitButtonTextColor || "white",
                    boxSizing: "border-box",
                    border: `2px solid ${submitButtonColor || "#13235b"}`,
                  }
                : {
                    backgroundColor: submitButtonColor || "#13235b",
                    color: submitButtonTextColor || "white",
                  }
            }
          >
            ←
          </button>
        )}
        {canGoForward && (
          <button
            onClick={onNext}
            className="p-2 rounded-lg hover:opacity-90 disabled:opacity-50 transition-colors"
            style={
              isTransparent
                ? {
                    backgroundColor: `${submitButtonColor || "#13235b"}50`,
                    color: submitButtonTextColor || "white",
                    boxSizing: "border-box",
                    border: `2px solid ${submitButtonColor || "#13235b"}`,
                  }
                : {
                    backgroundColor: submitButtonColor || "#13235b",
                    color: submitButtonTextColor || "white",
                  }
            }
          >
            →
          </button>
        )}
      </div>
      <button
        onClick={onSubmit}
        disabled={!canSubmit}
        className="px-6 py-2 rounded-lg w-full lg:w-auto transition-all hover:opacity-90 disabled:opacity-50"
        style={
          isTransparent
            ? {
                backgroundColor: `${submitButtonColor || "#13235b"}50`,
                color: submitButtonTextColor || "white",
                boxSizing: "border-box",
                border: `2px solid ${submitButtonColor || "#13235b"}`,
              }
            : {
                backgroundColor: submitButtonColor || "#13235b",
                color: submitButtonTextColor || "white",
              }
        }
      >
        {submitButtonText}
      </button>
    </div>
  );
};
